(function(){'use strict';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var MixAndMatchFilters=function(){function e(){_classCallCheck(this,e),this.init();}return _createClass(e,[{key:"init",value:function(){this.bindEvents();}},{key:"bindEvents",value:function(){var e=this;this.eventsBound||(document.querySelectorAll(".mix-and-match-filters .category__item").forEach((function(t){t.addEventListener("click",e.handleBubbleClick.bind(e));})),this.eventsBound=!0);}},{key:"handleBubbleClick",value:function(t){if(t.preventDefault(),t.stopPropagation(),!e.isProcessing){e.isProcessing=!0,t.currentTarget.classList.toggle("is-active");var i=this.getActiveFilters(),r=this.buildSearchParams(i);"undefined"!=typeof FacetFiltersForm?(FacetFiltersForm.renderPage(r,t,!0,"facets"),setTimeout((function(){e.isProcessing=!1;}),100)):e.isProcessing=!1;}}},{key:"getActiveFilters",value:function(){var e=document.querySelectorAll(".mix-and-match-filters .category__item.is-active");return Array.from(e).map((function(e){return e.dataset.filterValue}))}},{key:"buildSearchParams",value:function(e){var t=new URLSearchParams;new URLSearchParams(window.location.search).forEach((function(e,i){t.append(i,e);}));var i=[];return t.forEach((function(e,t){"filter.p.m.custom.product_category"===t&&i.push(t);})),i.forEach((function(e){t.delete(e);})),e.forEach((function(e){t.append("filter.p.m.custom.product_category",e);})),t.toString()}}]),e}();function restoreActiveStates(){var e=new URLSearchParams(window.location.search),t=[];e.forEach((function(e,i){"filter.p.m.custom.product_category"===i&&t.push(e);})),document.querySelectorAll(".mix-and-match-filters .category__item.is-active").forEach((function(e){e.classList.remove("is-active");})),t.forEach((function(e){var t=document.querySelector('.mix-and-match-filters .category__item[data-filter-value="'.concat(e,'"]'));t&&t.classList.add("is-active");}));}function initMixAndMatchFilters(){return new MixAndMatchFilters}_defineProperty(MixAndMatchFilters,"isProcessing",!1),document.addEventListener("DOMContentLoaded",(function(){initMixAndMatchFilters(),restoreActiveStates();})),document.addEventListener("grid-updated",(function(){MixAndMatchFilters.isProcessing||setTimeout((function(){return restoreActiveStates()}),10);}));})();